import ServicesSection from '../HomePage/ServicesSection'
import TransformativeSolutionsSection from '../HomePage/TransformativeSolutionsSection'
import ApproachSection from '../HomePage/ApproachSection'
import TestimonialsPage from '../HomePage/TestimonialsSection/TestimonialsPage'
import ServicesCtaSection from './ServicesCtaSection.jsx'
import SiteAmbient from '../common/SiteAmbient'
import { useTranslation } from 'react-i18next'
import scrollToHeroEmbed from '../../utils/scrollToHeroEmbed'

const TransformationServicesPage = () => {
  const { t } = useTranslation()
  return (
    <div className="relative isolate bg-transparent text-white font-Quicksand">
      <SiteAmbient />
      <section className="relative overflow-hidden py-28 px-6 md:px-16 flex items-center justify-center text-center">
        <div className="w-full max-w-6xl lg:max-w-[80%] space-y-6">
          <p className="text-xs uppercase tracking-[0.4em] text-pyramid-1">
            {t('services.hero_tag')}
          </p>
          <h1 className="text-4xl md:text-6xl font-black">
            {t('services.hero_heading')}
          </h1>
          <p className="text-xl text-slate-200 max-w-4xl mx-auto">
            {t('services.hero_body')}
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            <button
              onClick={scrollToHeroEmbed}
              className="rounded-[8px] bg-gradient-to-r from-pyramid-1 via-pyramid-10 to-pyramid-19 px-6 py-3 font-semibold text-ebony shadow-lg shadow-pyramid-10/40"
            >
              {t('services.hero_cta_talk')}
            </button>
          </div>
        </div>
      </section>
      <ServicesSection />
      <TransformativeSolutionsSection />
      <ApproachSection />
      <TestimonialsPage />
      <ServicesCtaSection />
    </div>
  )
}

export default TransformationServicesPage
